var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dropdown-item',{attrs:{"disabled":_vm.row.securityFuncFlag === 1},nativeOn:{"click":function($event){return _vm.toggleSecurity($event)}}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }